module.exports = __webpack_public_path__ + "static/media/bell-off.d9f7627d.svg";